<!-- Start: Rejwan: 09-02-2026 Front Routes -->

<template>

<div class="ibox">
    <div class="ibox-content p-3">
        <b-overlay  :show="showoverlayapproval" class='showoverlay_settle' rounded="sm">
            <div class="py-3" style="font-size: 13px;">
                <div class="text-center modal-title"><h5 class="modal-title">Approval</h5></div>
               
                <template v-if="settlement_fdata.application_status >= 0 "> 
                    <template  v-if="settlement_fdata.application_status_label == 'Settled'">
                        <div class="d-flex py-3">
                            <b-button class="employee-filter-btn  custom-secodary-btn" @click="downloadSettlementReport()"> Download Settlement Report</b-button>
                        </div>
                    </template>
                </template>

                <div class="d-flex py-3"> 
                    <div class="col-md-5 pl-0">Current Status: {{ settlement_fdata.application_status_label }}</div><!-- Mustafijur: 24-08-2026 -->
                    <div class="col-md-7 text-right pr-0"><!-- Mustafijur: 24-08-2026 -->
                        <!-- <b-button class="employee-filter-btn  custom-primary-btn" @click="showApprovalHistory()">  Approval History</b-button> -->
                        <b-button class="custom-primary-btn" @click="showApprovalHistory()">  Approval History</b-button> <!-- Rejwan: 06-03-2025 -->   
                        <template v-if="settlement_fdata.application_status == 1 "> 
                            <!-- <b-button class="employee-filter-btn  custom-primary-btn" @click="showBankFileHistory()"> Bank File History</b-button> -->
                            <!-- <b-button class="custom-primary-btn" @click="showBankFileHistory()"> Bank File History</b-button>  --> <!-- Rejwan: 23-08-2026 -->
                        </template>      
                    </div>                                        
                </div>
                
                <template v-if="can_approve == 1 & quick_view == 0">
                    <div class="d-flex">
                        <div class="col-md-7 mt-3 pl-0">
                            <b-form-group  id="settlement-status-group" label="Provide Decision" class="required-field"    label-for="settlement_type ">
                                    <b-form-select 
                                        id="approver_decision" name="approver_decision" data-vv-as="Decision" v-model="approver_decision" :state="validateState('approver_decision')" 
                                        :options="decision_option" v-validate="{ required: true }" >
                                        </b-form-select>
                                        <b-form-invalid-feedback id="approver_decision-feedback">{{ veeErrors.first('approver_decision') }}</b-form-invalid-feedback>
                            </b-form-group>  
                        </div>
                        
                        <div class="col-md-5 mt-3 pr-0">
                            <b-form-group  id="approver_remarks-group" label="Remarks" class="required-field" label-for="approver_remarks">
                                <b-form-textarea id="approver_remarks" :state="validateState('approver_remarks')" name="approver_remarks" v-model="approver_remarks" v-validate="{ required: true }" rows="5" max-rows="6"  no-resize   aria-describedby="settlement_details-feedback" data-vv-as="Details"></b-form-textarea>
                                <b-form-invalid-feedback id="approver_remarks-feedback">{{ veeErrors.first('approver_remarks') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                    </div>
                </template>
                <template v-if="can_approve && quick_view == 0">
                    <div class="mt-1 ml-4 mb-4 pb-3 clearfix text-center" style="margin-right: 18px;">
                        <template v-if="settlement_fdata.application_status == -1">
                            <b-button class="border rounded bg-light py-1 px-5 mt-4 ml-2" variant="primary" @click="consentSubmit()">Submit Consent</b-button>
                        </template>
                        <template v-if="settlement_fdata.application_status == 0">
                            <b-button class="border rounded bg-light py-1 px-5 mt-4 ml-2" variant="primary" @click="submitApproval()">Submit </b-button>
                        </template>
                        
                    </div>
                </template>
                <template v-if="action_type=='hold' && quick_view == 0">
                    <div class="d-flex">
                        <div class="col-md-7 mt-3 pl-0">
                          
                        </div> 
                        
                        <div class="col-md-5 mt-3 pr-0">
                            <b-form-group  id="approver_remarks-group" label="Remarks" class="required-field" label-for="approver_remarks">
                                <b-form-textarea id="approver_remarks" :state="validateState('approver_remarks')" name="approver_remarks" v-model="approver_remarks" v-validate="{ required: true }" rows="5" max-rows="6"  no-resize   aria-describedby="settlement_details-feedback" data-vv-as="Details"></b-form-textarea>
                                <b-form-invalid-feedback id="approver_remarks-feedback">{{ veeErrors.first('approver_remarks') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                    </div>
                    <template>
                        <div class="mt-1 ml-4 mb-4 pb-3 clearfix text-center" style="margin-right: 18px;">
                            <b-button class="border rounded bg-light py-1 px-5 mt-4 ml-2" variant="primary" @click="submitHold()">Hold</b-button> 
                        </div>
                        
                    </template>
                </template>

                <template v-if="action_type=='release' && quick_view == 0">
                    <div class="d-flex">
                        <div class="col-md-7 mt-3 pl-0">
                          
                        </div>
                        
                        <div class="col-md-5 mt-3 pr-0">
                            <b-form-group  id="approver_remarks-group" label="Remarks" class="required-field" label-for="approver_remarks">
                                <b-form-textarea id="approver_remarks" :state="validateState('approver_remarks')" name="approver_remarks" v-model="approver_remarks" v-validate="{ required: true }" rows="5" max-rows="6"  no-resize   aria-describedby="settlement_details-feedback" data-vv-as="Details"></b-form-textarea>
                                <b-form-invalid-feedback id="approver_remarks-feedback">{{ veeErrors.first('approver_remarks') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                    </div>
                    <template>
                        <div class="mt-1 ml-4 mb-4 pb-3 clearfix text-center" style="margin-right: 18px;">
                            <b-button class="border rounded bg-light py-1 px-5 mt-4 ml-2" variant="primary" @click="submitRealese()">Release</b-button> 
                        </div>
                        
                    </template>
                </template>

                <template v-if="action_type=='resubmit' && quick_view == 0">
                    <div class="d-flex">
                        <div class="col-md-7 mt-3 pl-0">
                          
                        </div>
                        <div class="col-md-5 mt-3 pr-0">
                            <b-form-group  id="approver_remarks-group" label="Remarks" class="required-field" label-for="approver_remarks">
                                <b-form-textarea id="approver_remarks" :state="validateState('approver_remarks')" name="approver_remarks" v-model="approver_remarks" v-validate="{ required: true }" rows="5" max-rows="6"  no-resize   aria-describedby="settlement_details-feedback" data-vv-as="Details"></b-form-textarea>
                                <b-form-invalid-feedback id="approver_remarks-feedback">{{ veeErrors.first('approver_remarks') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                    </div>
                    <template>
                        <div class="mt-1 ml-4 mb-4 pb-3 clearfix text-center" style="margin-right: 18px;"> 
                            <b-button class="border rounded bg-light py-1 px-5 mt-4 ml-2" variant="primary" :disabled="disable_approval" @click="submitRealese()">Re-Submit</b-button> 
                        </div>
                        
                    </template>
                </template>

            </div>
    
        
        </b-overlay>
        <b-modal id="bv-modal-approval-history" size="lg" hide-footer v-bind:title="approval_history_label">
            <div class="col-sm-12 mt-1 mb-1"> 
                <!-- Start: Rejwan: 09-02-2026 Front Routes -->
                <!-- <approval-history :pageurl="$api_url" :application_id="this.settlement_fdata.application_id"  module="9" :company_id='this.settlement_fdata.company_id' :key="thread_key" ></approval-history> -->
                <advance-settlement-approver-approval-history-front :pageurl="$api_url" :application_id="this.settlement_fdata.application_id"  module="9" :company_id='this.settlement_fdata.company_id' :key="thread_key" ></advance-settlement-approver-approval-history-front>
                <!-- End: Rejwan: 09-02-2026 Front Routes -->
            </div>               
        </b-modal> 
        

        <!-- <bank-file-history :pageurl="$api_url" :instrument_id="instrument_id" :instrument_type="history_type" :key="history_key" ></bank-file-history> --> <!-- Start: Rejwan: 09-02-2026 Front Routes -->
        <!-- <bank-file-history-front  modal_id="bv-modal-bank-file-history-front"  :pageurl="$api_url" :instrument_id="instrument_id" :instrument_type="history_type" :key="history_key1" ></bank-file-history-front>  -->
        <!-- Start: Rejwan: 09-02-2026 Front Routes -->
      

        <b-modal size="lg" id="bv-modal-consent-submit" hide-footer :title="'Thank You'">
            <div>Thank you for submitting your decision.</div>
            <div class="mt-3">Based on approval rules and regulations, you may receive further communication/notifications regarding your Provident Fund Settlement at a later date</div>
            <div class="mt-3">The link which you have followed will no longer be functional.</div>
            <div class="mt-3">Have a good day.</div>
        </b-modal>
    </div>

</div>
</template>


<script>
    
    export default{ 
        
        mounted() {
            
            
        },
        props: ['pageurl','settlement_fdata','action_type','quick_view','disable_approval'],
        components: {
           
        },
        data(){             
           
        
            return { 
                approval_history_label:'Approval History',
               
                pf_from_disable:false,
                form_status:0,
                disable_amount:true,
                disabled:true,
                decision_option: [{text:'Approve',value:1},{text:'Defer',value:2}, {text:'Reject',value:3}], 
                status_options: [{text:'Awaiting Consent',value:-1},{text:'Applied',value:2}, {text:'Approved',value:3}],
                can_approve:false,
                thread_key:0,
                approver_remarks:'',
                approver_decision:null,
                showoverlayapproval:false,
                history_type:2,
                history_key1:0, // Rejwan: 30-06-2025 Modal Problem
                instrument_id:0,
            
    
            }
        },
        methods:{
            downloadSettlementReport() 
            {
                let currentObj = this;
                let formData = new FormData();
                formData.append('settlement_id', this.settlement_fdata.id);

                // axios.post(this.$api_url+'/pf/settl-download-pdfbankfile' , formData) // Start: Rejwan: 09-02-2026 Front Routes
                // axios.post(this.$api_url_front+'/pf/settl-download-pdfbankfile' , formData) // Start: Rejwan: 09-02-2026 Front Routes
                // .then(function (response) 
                // {                       
                //     // download the file here using ghost                      
                //     // this.downloadFileContent(response.data);
                //     this.downloadFileContent(response.data, 1);
                    
                // }.bind(this))
                // .catch(function (error) 
                // {                          
                //     this.showoverlay = false;                        
                //     currentObj.serverError(error);
                // });
                this.downloadBlobResponse(
                    axios.post(this.$api_url_front + '/pf/settl-download-pdfbankfile', formData, { responseType: 'blob' }),
                    'loader' // your loader key in this component
                );
            },
            showApprovalHistory(){
                this.thread_key +=1;
                this.$bvModal.show('bv-modal-approval-history');
            },
           
            showBankFileHistory(){
                 this.instrument_id = this.settlement_fdata.id;
                 this.history_key1 += 1; // Rejwan: 30-06-2025 Modal Problem
            },
            hideBankFileHistory(){
                 this.$bvModal.hide('bv-modal-bank-file-history');
            },
            consentSubmit()
            {
                let settle_data = this.settlement_fdata;
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => { 
                    if (!result) { 
                        return;
                    }
                    
                    let currentObj = this;
                    currentObj.showoverlayapproval = true;
                    let formData = new FormData();
                    formData.append('id', settle_data.id);
                    formData.append('employee_id', settle_data.employee_id);
                    formData.append('approval_application_id', settle_data.application_id );
                    formData.append('approval_user_type', 0 );
                    formData.append('approval_approver_id', 0);
                    formData.append('approval_status', this.approver_decision);
                    formData.append('approval_comment', this.approver_remarks); 
                    formData.append('approval_module', 9);
                    
                    // axios.post(this.$api_url+'/approver/consent', formData) // Start: Rejwan: 09-02-2026 Front Routes
                    axios.post(this.$api_url_front+'/approver/consent', formData) // Start: Rejwan: 09-02-2026 Front Routes
                    .then(function (response) 
                    {
                        currentObj.showoverlayapproval = false;
                        currentObj.$emit('childToParent'); 
                    });
                });
            }, 

            submitApproval()
            {
                let settle_data = this.settlement_fdata;
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => { 
                    if (!result) { 
                        return;
                    }
                    
                    let currentObj = this;
                    currentObj.showoverlayapproval = true;
                    let formData = new FormData();
                    formData.append('id', settle_data.id);
                    formData.append('employee_id', settle_data.employee_id);
                    formData.append('approval_application_id', settle_data.application_id );
                    formData.append('approval_user_type', 0 );
                    formData.append('approval_approver_id', 0);
                    formData.append('approval_status', this.approver_decision);
                    formData.append('approval_comment', this.approver_remarks); 
                    formData.append('approval_module', 9);
                    
                    // axios.post(this.$api_url+'/approver/submit-approval', formData) // Start: Rejwan: 09-02-2026 Front Routes
                    axios.post(this.$api_url_front+'/approver/submit-approval', formData) // Start: Rejwan: 09-02-2026 Front Routes
                    .then(function (response) 
                    {
                        currentObj.showoverlayapproval = false;
                        currentObj.$emit('childToParent');
                    });
                });
            },
            submitHold()
            {
                let settle_data = this.settlement_fdata;
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => { 
                    if (!result) { 
                        return;
                    }
                    
                    let currentObj = this;
                    currentObj.showoverlayapproval = true;
                    let formData = new FormData();
                    formData.append('settlement_id', settle_data.id);
                    formData.append('approval_application_id', settle_data.application_id );
                    formData.append('approval_user_type', 0 );
                    formData.append('approval_approver_id', 0);
                    formData.append('approval_comment', this.approver_remarks); 
                    formData.append('approval_module', 9);
                    
                    // axios.post(this.$api_url+'/approver/submit-hold', formData) // Start: Rejwan: 09-02-2026 Front Routes
                    axios.post(this.$api_url_front+'/approver/submit-hold', formData) // Start: Rejwan: 09-02-2026 Front Routes
                    .then(function (response) 
                    {
                        currentObj.$bvToast.toast('Success', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });
                        currentObj.showoverlayapproval = false;
                        currentObj.$emit('childToParent');
                    });
                });
                
            },
            submitRealese()
            {
                let settle_data = this.settlement_fdata;
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => { 
                    if (!result) { 
                        return;
                    }
                    
                    let currentObj = this;
                    currentObj.showoverlayapproval = true;
                    let formData = new FormData();
                    formData.append('settlement_id', settle_data.id);
                   
                    formData.append('approval_application_id', settle_data.application_id );
                    formData.append('approval_user_type', 0 );
                    formData.append('approval_approver_id', 0);
                    formData.append('approval_comment', this.approver_remarks); 
                    formData.append('approval_module', 9);
                    
                    // axios.post(this.$api_url+'/approver/submit-release', formData) // Start: Rejwan: 09-02-2026 Front Routes
                    axios.post(this.$api_url_front+'/approver/submit-release', formData) // Start: Rejwan: 09-02-2026 Front Routes
                    .then(function (response) 
                    {
                        currentObj.$bvToast.toast('Success', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });
                        currentObj.showoverlayapproval = false;
                        currentObj.$emit('childToParent');
                    });
                });
                
            },

            

        },
        created: function(){
            if(this.settlement_fdata.application_can_approve == 1)
            {
                this.can_approve = true;

                if(this.settlement_fdata.application_status == -1)
                {
                    this.decision_option = [{text:'Select Decision',value:null},{text:'Consent',value:1},{text:'Defer',value:2}, {text:'Reject',value:3}];
                }
                else
                {
                    this.decision_option = [{text:'Select Decision',value:null},{text:'Approve',value:1},{text:'Defer',value:2}, {text:'Reject',value:3}];
                }
            }
            else
            {
                this.can_approve = false;
            }
        },
        computed: 
        {
           
        }
    }
</script>
<!-- End: Rejwan: 09-02-2026 Front Routes -->
